import React from 'react';

// Shown when a list fetch fails. Without this a failed request is indistinguishable
// from an empty result — the page says "nothing here" and offers no way to retry.
const CloudOffIcon = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const LoadError = ({
  title = 'Couldn’t load this',
  message = 'Check your connection and try again.',
  onRetry,
  retrying = false,
}) => (
  <div className="load-error" role="alert">
    <CloudOffIcon />
    <h3 className="load-error__title">{title}</h3>
    <p className="load-error__msg">{message}</p>
    {onRetry && (
      <button type="button" className="load-error__retry" onClick={onRetry} disabled={retrying}>
        {retrying ? 'Retrying…' : 'Try again'}
      </button>
    )}
  </div>
);

export default LoadError;
